export default __webpack_public_path__ + "static/media/insta11.94b6cca5.webp";